export const OUTLOOK_PREFIX = 'outlook';

const getRedirectOrigin = () => {
    // Use dev url for local development (*.local domains)
    if (window.location.hostname.endsWith('.local') && import.meta.env.VITE_DEV_BASE_URL) {
        return import.meta.env.VITE_DEV_BASE_URL;
    }

    return window.location.origin.replace(new RegExp(/(https:\/\/)([\w-]+)(\..+)/i), '$1app$3');
};

const getRedirectUri = () => {
    // Dynamically import router to avoid circular dependency
    return import('../../router/router').then(({default: router}) => {
        return getRedirectOrigin() + router.resolve({name: 'AdminCalendarSettings'}).href;
    });
};

export const getOutlookConfig = async () => ({
    url: 'https://login.microsoftonline.com/organizations/adminconsent',
    clientId: import.meta.env.VITE_OAUTH_AZURE_ID,
    redirectUri: await getRedirectUri(),
    scope: 'https://graph.microsoft.com/calendars.readwrite place.read.all',
});

// Legacy export for backward compatibility
export const outlookConfig = {
    url: 'https://login.microsoftonline.com/organizations/adminconsent',
    clientId: import.meta.env.VITE_OAUTH_AZURE_ID,
    get redirectUri() {
        return getRedirectOrigin() + '/en/admin/calendar-settings';
    },
    scope: 'https://graph.microsoft.com/calendars.readwrite place.read.all',
};
